module.exports = "data:application/vnd.ms-fontobject;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJjZWQ2MTFkYWY3NzA5Y2M3NzhkYTkyOGZlYzg3NjQ3NS5lb3QiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/slick-carousel/slick/fonts/slick.eot
// module id = 563
// module chunks = 0